module.exports = __webpack_public_path__ + "static/media/foto10.af88ca35.jpg";